import styles from './TableMenu.module.scss.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Text } from '../../text/Text.js';
import classNames from 'clsx';

function TableMenuGroupHeader(props) {
  const {
    children,
    size,
    tag
  } = props;
  const className = classNames(styles['group-header'], styles[`size-${size}`]);
  const content = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: styles['col']
    }), /*#__PURE__*/jsx("div", {
      className: styles['col'],
      children: /*#__PURE__*/jsx(Text, {
        variant: size === 'small' ? 'menu-heading-small' : 'menu-heading',
        children: children
      })
    }), /*#__PURE__*/jsx("div", {
      className: styles['col']
    }), /*#__PURE__*/jsx("div", {
      className: styles['col']
    })]
  });
  return /*#__PURE__*/jsx("div", {
    className: className,
    "data-dsx--menu-group-header": tag,
    children: content
  });
}

export { TableMenuGroupHeader };
